<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Залы</div>
            </div>
            <div class="panel-body pn">
                <per-pager v-bind:per-page="pagination.perPage"></per-pager>
                <table class="table table-striped table-hover datatables" id="clients_list" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>id</th>
                            <th>Наменование</th>
                            <th>Филиал</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(room, index) in rooms" v-bind:key="index">
                            <td>{{room.id}}</td>
                            <td>
                                <router-link :to="{name: 'fitness-rooms-edit', params: {id: room.id}}">
                                    {{room.name}}
                                </router-link>
                            </td>
                            <td>{{data.filiations.find(filiation => filiation.id === room.filiationId).name}}</td>
                        </tr>
                    </tbody>
                </table>
                <paginator v-bind="pagination"></paginator>
            </div>
        </div>
    </div>
</template>

<script>
    import FitnessRoom from "../../models/FitnessRoom";
    import Filiation from "../../models/Filliation";

    export default {
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                data: {
                    filiations: [],
                },
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                rooms: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        methods: {
            async load() {
                this.isLoading = true;
                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();

                const filiationsData = await Filiation.getList(1, 999);
                this.data.filiations = filiationsData.data;

                const {data, headers} = await FitnessRoom.getList(page, perPage);
                this.setData(data, headers);
                this.isLoading = false;
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['rooms-list']) {
                    return this.$store.state.template.perPages['rooms-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'rooms-list', value: value})
            },
            setData(rooms, headers) {
                this.rooms = rooms;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            }
        },
        metaInfo() {
            return {
                title: 'Залы - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>